/* import __COLOCATED_TEMPLATE__ from './gain-tempco.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();